import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_ph4BSRgSCEuQ: {
	id: 'prd_ph4BS2DEV2RgSCEuQ'
	ident: 'prd_ph4BSRgSCEuQ'
	sku: 'simple_premium_12w_21_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_wuNM42DEV2z9oPBcz'
			amount: 79
			amount_usd: 21.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 21.99
			discount: 57.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_IIyg92DEV2Ms6eXS7'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_ph4BSRgSCEuQ, SubscriptionProduct>
const prd_ph4BSRgSCEuQ = { ident: 'prd_ph4BSRgSCEuQ' } as typeof _prd_ph4BSRgSCEuQ

export default prd_ph4BSRgSCEuQ
